export const menuItems = [
  {
    label: "FABRICS",
    value: "fabrics",
    dropdown: [
      { label: "Georgette", value: "georgette-fabric" },
      {
        label: "Ikkat cotton",
        value: "ikkat-cotton-fabric",
      },
      { label: "Twile delight", value: "twile-delight-fabric" },
      { label: "Viscose", value: "viscose-fabric" },
      { label: "Checked Cotton", value: "checked-cotton-fabric" },
      { label: "Dupion Digital", value: "dupion-digital-fabric" },
      { label: "Organza", value: "organza-fabric" },
      { label: "Organza Printed", value: "organza-printed-fabric" },
      { label: "Organza Sequence", value: "organza-sequence-fabric" },
      { label: "Brocade Shiny", value: "brocade-shiny-fabric" },
      { label: "Banarasi Brocade", value: "banarasi-brocade-fabric" },
      { label: "Brasso Net", value: "brasso-net-fabric" },
      { label: "Embroidery Cotton", value: "embroidery-cotton-fabric" },
      { label: "Embroidery Net", value: "embroidery-net-fabric" },
      { label: "Shimmer Net", value: "shimmer-net-fabric" },
      { label: "Plain Net", value: "plain-net-fabric" },
      {
        label: "Georgette Floral Sequence",
        value: "georgette-floral-sequence-fabric",
      },
      { label: "Kalamkari", value: "kalamkari-fabric" },
      { label: "Lace Net", value: "lace-net-fabric" },
      { label: "Lycra", value: "lycra-fabric" },
      { label: "Plain Cotton", value: "plain-cotton-fabric" },
       { label: "Plain Georgette", value: "plain-georgette-fabric" },
      { label: "Printed Cotton", value: "printed-cotton-fabric" },
      { label: "Printed Satin", value: "printed-satin-fabric" },
      { label: "Silicon Georgette", value: "silicon-georgette-fabric" },
      { label: "Viscose Organza", value: "viscose-organza-fabric" },
      { label: "Satin Georgette", value: "satin-georgette-fabric" },
      { label: "Chiffon", value: "chiffon-fabric" },

      // { label: "New Arrivals", value: "new-arrivals-fabrics" },
      // {
      //     label: "Printed Fabrics",
      //     value: null,
      //     subcategories: [
      //         { label: "Japan Satin", value: "japan-satin-fabric" },
      //         { label: "Mulmul", value: "mulmul-fabric" },
      //         { label: "Crepe Silk", value: "crepe-silk-fabric" },
      //         { label: "Art Silk", value: "art-silk-fabric" },
      //         { label: "Glazed Cotton", value: "glazed-cotton-fabric" },
      //         { label: "Cotton Cambric", value: "cambric-cotton-fabric" },
      //         { label: "Kota Doria", value: "kota-doria-fabric" },
      //         { label: "Bemberg Chiffon", value: "bemberg-chiffon-fabric" },
      //         { label: "Gaji Silk", value: "gaji-silk-fabric" },
      //         { label: "Pure Linen", value: "pure-linen-fabric" },
      //         { label: "Georgette", value: "georgette-fabric" },
      //         { label: "Georgette Satin", value: "georgette-satin-fabric" },
      //         { label: "Viscose Georgette", value: "viscose-georgette-fabric" },
      //         { label: "Moss Georgette", value: "moss-georgette-fabric" },
      //         { label: "Poly Cambric", value: "poly-cambric-fabric" },
      //         { label: "Pashmina", value: "pashmina-fabric" },
      //         { label: "Natural Crepe", value: "natural-crepe-fabric" },
      //         { label: "Chiffon Satin", value: "chiffon-satin-fabric" },
      //         { label: "Imported Satin", value: "imported-satin-fabric" },
      //         { label: "Lush Satin", value: "lush-satin-fabric" },
      //         { label: "Charmeuse Satin", value: "charmeuse-satin-fabric" },
      //         { label: "Viscose Muslin", value: "viscose-muslin-fabric" },
      //         { label: "Muslin", value: "muslin-fabric" },
      //         { label: "Velvet", value: "velvet-fabric" },
      //         { label: "Velvet 58", value: "velvet-58-fabric" },
      //         { label: "Pure Organza", value: "pure-organza-fabric" },
      //         { label: "Liquid Organza", value: "liquid-organza-fabric" }
      //     ],
      // },
      // {
      //     label: "Plain/Dyed Fabrics",
      //     value: null,
      //     subcategories: [
      //         { label: "Cotton Flex", value: "cotton-flex-fabric" },
      //         { label: "Blend Cotton Slub", value: "blend-cotton-slub-fabric" },
      //         { label: "Glazed Cotton", value: "glazed-cotton-plain-fabric-" },
      //         { label: "Cotton Cambric", value: "cotton-cambric-fabric" },
      //         { label: "Viscose Modal Silk", value: "viscose-modal-silk-fabric" },
      //         { label: "Cotton Mulmul", value: "cotton-mulmul-fabric" },
      //         { label: "Pure Natural Crepe", value: "pure-natural-crepe-fabric" },
      //         { label: "Pure Organza", value: "pure-organza-plain-fabric" },
      //         { label: "Imported Satin", value: "imported-satin-plain-fabric" },
      //         { label: "Pure Georgette", value: "pure-georgette-fabric" },
      //         { label: "Moss Georgette", value: "moss-georgette-plain-fabric" },
      //         { label: "Georgette", value: "georgette-plain-fabric" },
      //         { label: "Japan Satin", value: "japan-satin-plain-fabric" },
      //         { label: "Chiffon Satin", value: "chiffon-satin-plain-fabric" },
      //         { label: "Pure Dola Silk", value: "pure-dola-silk-fabric" },
      //         { label: "Liquid Organza", value: "liquid-organza-plain-fabric" },
      //         { label: "Butter Crepe", value: "butter-crepe-fabric" },
      //         { label: "Ultra Satin", value: "ultra-satin-fabric" },
      //         { label: "Muslin", value: "muslin-plain-fabric" },
      //         { label: "Kota Doria", value: "kota-doria-plain-fabric" },
      //         { label: "Net", value: "net-fabric" },
      //         { label: "Chinnon Chiffon", value: "chinnon-chiffon-fabric" },
      //         { label: "Banana Crepe", value: "banana-crepe-fabric" },
      //         { label: "Suede", value: "suede-fabric" },
      //         { label: "Habutai Silk", value: "habutai-silk-fabric" },
      //         { label: "Cotton Lycra", value: "cotton-lycra-fabric" },
      //         { label: "Semi Scuba", value: "semi-scuba-fabric" },
      //         { label: "Mashru Silk", value: "mashru-silk-fabric" },
      //         { label: "Stretch Cotton", value: "stretch-cotton-fabric" },
      //         { label: "Crepe", value: "crepe-fabric" },
      //         { label: "Neon", value: "neon-plain-fabric" },
      //         { label: "Velvet", value: "velvet-plain-fabric" },
      //         { label: "Cotton", value: "cotton-plain-fabric" },
      //         { label: "Pin-Tucks", value: "pin-tucks-plain-fabric" },
      //         { label: "Chanderi", value: "chanderi-fabric" },
      //         { label: "Rayon", value: "rayon-fabric" },
      //         { label: "Plain Lycra", value: "plain-lycra-fabric" }
      //     ],
      // },
      // {
      //     label: "Design and Pattern",
      //     value: null,
      //     subcategories: [
      //         { label: "Animal", value: "animal-fabric" },
      //         { label: "Checks", value: "checks-fabric" },
      //         { label: "Chevron", value: "chevron-fabric" },
      //         { label: "Christmas", value: "christmas-fabric" },
      //         { label: "Leaf", value: "leaf-fabric" },
      //         { label: "Leheriya", value: "leheriya-fabric" },
      //         { label: "Mix N Match", value: "mix-n-match-fabric" },
      //         { label: "Mughal Print", value: "mughal-print-fabric" },
      //         { label: "Quirky", value: "quirky-fabric" },
      //         { label: "Paisley", value: "paisley-fabric" },
      //         { label: "Patola", value: "patola-fabric" },
      //         { label: "Polka Dots", value: "polka-dots-fabric" },
      //         { label: "Trellis", value: "trellis-fabric" },
      //         { label: "Stripes", value: "stripes-fabric" },
      //         { label: "Floral", value: "floral-design-fabric" },
      //         { label: "Ethnic", value: "ethnic-fabric" },
      //         { label: "Valentine's", value: "-fabric" },
      //         { label: "Geometric", value: "valentines-fabric" },
      //         { label: "Abstract", value: "abstract-fabric" },
      //         { label: "Traditional", value: "traditional-fabric" },
      //         { label: "Tricolor", value: "tricolor-fabric" },
      //         { label: "Tie & Dye", value: "tie-n-dye-fabric" },
      //         { label: "Kids Print", value: "kids-print-fabric" },
      //         { label: "Gamthi", value: "gamthi-fabric" },
      //         { label: "Illusion", value: "illusion-fabric" },
      //         { label: "Booti", value: "booti-fabric" },
      //         { label: "Feather", value: "feather-fabric" },
      //         { label: "Halloween", value: "halloween-fabric" },
      //         { label: "Chain", value: "chain-fabric" },
      //         { label: "Madhubani & Pichwaii", value: "madhubani-n-pichwaii-fabric" },
      //         { label: "Denim", value: "denim-fabric" },
      //         { label: "Tropical", value: "tropical-fabric" },
      //         { label: "Rainbow", value: "rainbow-fabric" },
      //         { label: "Marble", value: "marble-fabric" },
      //         { label: "Map", value: "map-design-fabric" },
      //         { label: "Newspaper", value: "newspaper-fabric" },
      //         { label: "Social Media", value: "social-media-fabric" },
      //         { label: "Camouflage", value: "camouflage-fabric" },
      //         { label: "Egyptian", value: "egyptian-fabric" },
      //         { label: "Ombre", value: "ombre-fabric" },
      //         { label: "Bistro", value: "bistro-fabric" },
      //         { label: "Butterfly", value: "butterfly-fabric" },
      //         { label: "Heart", value: "heart-fabric" },
      //         { label: "Bird", value: "bird-fabric" },
      //         { label: "Patch", value: "patch-fabric" },
      //         { label: "Texture", value: "texture-fabric" },
      //         { label: "Bandhani", value: "bandhani-fabric" },
      //         { label: "Pin-Tucks", value: "pin-tucks-design-fabric" },
      //     ],
      // },
      // {
      //     label: "Indian Crafts",
      //     value: null,
      //     subcategories: [
      //         { label: "Ajrakh", value: "ajrakh-fabric" },
      //         { label: "Banarasi", value: "banarasi-fabric" },
      //         { label: "Dabu", value: "dabu-fabric" },
      //         { label: "Handloom", value: "handloom-fabric" },
      //         { label: "Ikatw", value: "ikatw-fabric" },
      //         { label: "Indigo", value: "indigo-fabric" },
      //         { label: "Kalamkari", value: "kalamkari-fabric" },
      //         { label: "Kashish", value: "kashish-fabric" },
      //         { label: "Monochrome", value: "monochrome-fabric" },
      //         { label: "Batik", value: "batik-fabric" },
      //         { label: "Shibori", value: "shibori-fabric" },
      //         { label: "Kantha", value: "kantha-fabric" },
      //         { label: "Bagh Print", value: "bagh-print-fabric" }
      //     ],
      // },
      // {
      //     label: "Work and Embroidery",
      //     value: null,
      //     subcategories: [
      //         { label: "Premium Embroidery Fabric", value: "premium-emboridery-fabric" },
      //         { label: "Premium Sequins Georgette", value: "premium-sequins-georgette-fabric" },
      //         { label: "Velvet Sequins Fabric", value: "velvet-sequins-fabric" },
      //         { label: "Position Print", value: "position-print-fabric" },
      //         { label: "Sequins Fabric", value: "sequins-fabric" },
      //         { label: "Swarovski", value: "swarovski-fabric" },
      //         { label: "Bemberg Crepe Lurex", value: "bemberg-crepe-lurex-fabric" },
      //         { label: "Printed Embroidery Fabric", value: "printed-embroidery-fabric" },
      //         { label: "Printed Sequins Fabric", value: "printed-sequins-fabric" },
      //         { label: "Lucknowi Fabric", value: "lucknowi-fabric" },
      //         { label: "Foil Print Fabric", value: "foil-print-fabric" },
      //         { label: "Dyeable Embroidery Fabric", value: "dyeable-embroidery-fabric" },
      //         { label: "Handblock Sequins Fabric", value: "handblock-sequins-fabric" },
      //         { label: "Sequins Georgette Fabric", value: "sequins-georgette-fabric" },
      //         { label: "Schiffli Embroidery Fabric", value: "schiffli-embroidery-fabric" },
      //         { label: "Texture Sequins Fabric", value: "texture-sequin-fabric" },
      //         { label: "Handblock Embroidery Fabric", value: "handblock-embroidery-fabric" },
      //         { label: "Mirror Embroidery Printed Fabric", value: "mirror-embroidery-printed-fabric" },
      //         { label: "Sequins Crepe Fabric", value: "sequins-crepe-fabric" },
      //     ],
      // },
      // {
      //     label: "Pleated Fabric",
      //     value: null,
      //     subcategories: [
      //         { label: "Printed Pleated Fabric", value: "printed-pleated-fabric" },
      //         { label: "Plain Pleated Fabric", value: "plain-pleated-fabric" },
      //     ],
      // },
      // { label: "Dyealble Fabric", value: "dyealble-fabric" },
      // {
      //     label: "Organic Fabric", value: null,
      //     subcategories: [
      //         { label: "Eucalyptus", value: "eucalyptus-fabric" },
      //         { label: "Orange", value: "orange-fabric" },
      //         { label: "Milk", value: "milk-fabric" },
      //         { label: "Corn", value: "corn-fabric" }
      //     ],
      // },
      // {
      //     label: "Rangmanch", value: null,
      //     subcategories: [
      //         { label: "Yellow", value: "yellow-fabric" },
      //         { label: "Red", value: "red-fabric" },
      //         { label: "Black", value: "black-fabric" },
      //         { label: "Blue", value: "blue-fabric" },
      //         { label: "Peach", value: "peach-fabric" },
      //         { label: "Mellow Yellow", value: "mellow-yellow-fabric" },
      //         { label: "Sky Blue", value: "sky-blue-fabric" },
      //         { label: "Salmon Pink", value: "salmon-pink-fabric" },
      //         { label: "Lime Green", value: "lime-green-fabric" },
      //         { label: "Hickory Brown", value: "-hickory-brown-fabric" },
      //         { label: "Peacock Blue", value: "peacock-blue-fabric" },
      //         { label: "Bottle Green", value: "bottle-green-fabric" },
      //     ],
      // },
      // { label: "Imported Fabrics", value: "imported-fabrics" },
      // {
      //     label: "Furnishing",
      //     value: null,
      //     subcategories: [
      //         { label: "Certain Febric", value: "certain-fabric" },
      //         { label: "Sheer Febric", value: "sheer-fabric" },
      //         { label: "Shofa Febric", value: "shofa-fabric" },
      //         { label: "Coshion Cover", value: "coshion-cover-fabric" },
      //     ],
      // },
      // { label: "Customer Choice", value: "customer-choice-fabric" },
      // { label: "Fabric Book", value: "fabric-book" },
    ],
  },
  {
    label: "SAREES",
    value: "sarees",
    dropdown: [   
      { label: "Designer Saree", value: "designer-sarees" },
      { label: "Dupion Saree", value: "dupion-sarees" },
      { label: "Tissue Zardozi Saree", value: "tissue-zardozi-sarees" },
      { label: "Ikkath Pochamali Saree", value: "ikkath-pochamali-sarees" },
      { label: "Ikkath Saree", value: "ikkath-sarees" },
      { label: "Kota Silk Cotton Saree", value: "kota-silk-cotton-sarees" },
      { label: "Banarasi silk Saree", value: "banarasi-silk-sarees" },
      { label: "Raw Mango Silk Saree", value: "raw-mango-silk-sarees" },
      { label: "Orange Floral Saree", value: "orange-floral-sarees" },
      { label: "Tissue Banarsi Saree", value: "tissue-banarsi-sarees" },
      { label: "Tissue Antique Saree", value: "tissue-antique-sarees" },
      { label: "Tussar Meenakari Saree", value: "tussar-meenakari-sarees" },
      { label: "Kora Antique Saree", value: "kora-antique-sarees" },
      { label: "Kora Designer Saree", value: "kora-designer-sarees" },
      { label: "Dupion Rankat Saree", value: "dupion-rankat-sarees" },
      { label: "Banarszi Tissue Saree", value: "banarszi-tissue-sarees" },
      { label: "Silk Cotton Saree", value: "silk-cotton-sarees" },
      { label: "Pure Silk Saree", value: "pure-silk-sarees" },
      { label: "Chandhiri Silk Saree", value: "chandhiri-silk-sarees" },
      { label: "Cotton Saree", value: "cotton-sarees" },
      { label: "Mulbery-Cotton Saree", value: "mulbery-cotton-sarees" }
    ],
  },
  {
    label: "UNIQUE COSTUMES",
    value: "Unique Costumes",
    dropdown: [
      { label: "Long Gown", value: "long-gown" },
      { label: "Short Gown", value: "short-gown" },
      {
        label: "Kurtis",
        value: null,
        subcategories: [
          { label: "Cotton Kurtis", value: "cotton-kurtis" },
          { label: "Synthetic Kurtis", value: "synthetic-kurtis" },
          { label: "A Line Kurtis", value: "a-line-kurtis" },
          { label: "Panel Kurtis", value: "panel-kurtis" },
          { label: "Umberalla Kurtis", value: "umberalla-kurtis" },
        ],
      },
      { label: "Skirts", value: "skirts" },
      { label: "Peplum Top", value: "peplum-top" },
    ],
  },
  {
    label: "CUSTOMIZED FABRICS",
    value: "customized-fabrics",
    dropdown: [{ label: "Only Customized", value: "customized-fabrics" }],
  },
  {
    label: "AAVRYAAS EXCLUSIVE",
    value: "aavryaas-exclusive-fabrics",
    dropdown: [
      { label: "Exclusive Fabrics", value: "aavryaas-exclusive-fabrics" },
    ],
  },
  {
    label: "VINTAGE COLLECTION",
    value: "vintage-collection",
    dropdown: [{ label: "Vintage Collection", value: "vintage-collection" }],
  },
];
